export default __webpack_public_path__ + "static/media/japa.7e0b5929.jpg";